import {BlockSchema, TypesMatch, defaultProps} from './blocknote'
import {defaultBlockSchema} from './blocknote/core/extensions/Blocks/api/defaultBlocks'
import {common, createLowlight} from 'lowlight'
import {ButtonBlock} from './button'
// import {EmbedBlock} from "./embed-block";
import {HMHeadingBlockContent} from './heading-component-plugin'
import {FileBlock} from './file'
import {ImageBlock} from './image'
import {MathBlock} from './math'
import {NostrBlock} from './nostr'
// import {QueryBlock} from "./query-block";
import {SlotBlock} from './slot-block'
import CodeBlockLowlight from './tiptap-extension-code-block'
import {Table} from './tiptap-extension-table'
import {VideoBlock} from './video'
import {WebEmbed} from './web-embed'

export const hmBlockSchema: BlockSchema = {
  paragraph: defaultBlockSchema.paragraph,
  // heading: defaultBlockSchema.heading,
  heading: {
    propSchema: {
      ...defaultProps,
      level: {default: '1'},
    },
    node: HMHeadingBlockContent,
  },
  image: ImageBlock,
  ['code-block']: {
    propSchema: {
      ...defaultProps,
      language: {default: ''},
    },
    // @ts-ignore
    node: CodeBlockLowlight.configure({
      defaultLanguage: 'plaintext',
      lowlight: createLowlight(common),
      languageClassPrefix: 'language-',
    }),
  },

  video: VideoBlock,
  // embed: EmbedBlock,
  file: FileBlock,
  button: ButtonBlock,
  nostr: NostrBlock,
  ['web-embed']: WebEmbed,
  math: MathBlock('math'),
  // query: QueryBlock,
  table: {
    propSchema: {
      ...defaultProps,
    },
    // @ts-ignore
    node: Table,
  },
  slot: SlotBlock,
}

export type HMBlockSchema = TypesMatch<typeof hmBlockSchema>
